import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { SignedInNavigationScreenNavigationProp } from '../../../routes/types';
import {
  customerCartState,
  customerCartStatusState,
  productsCartState,
  productsCartStatusState,
} from '../../../store/batchTicket/atom';

export const useHeader = () => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isMobile = useBreakpointValue({ base: true, sm: false });

  const customerCartStatus = useRecoilValue(customerCartStatusState);
  const productsCartStatus = useRecoilValue(productsCartStatusState);

  const resetCustomerCart = useResetRecoilState(customerCartState);
  const resetProductsCart = useResetRecoilState(productsCartState);
  const resetCustomerCartStatus = useResetRecoilState(customerCartStatusState);
  const resetProductsCartStatus = useResetRecoilState(productsCartStatusState);

  const getCurrentStepAndTitle = () => {
    if (customerCartStatus === 'complete' && productsCartStatus !== 'complete') {
      return { step: 2, title: 'Adicione os produtos' };
    }

    if (customerCartStatus === 'complete' && productsCartStatus === 'complete') {
      return { step: 3, title: 'Personalize a boleta' };
    }

    return { step: 1, title: 'Adicione os clientes' };
  };

  const currentStep = getCurrentStepAndTitle().step;
  const stepTitle = getCurrentStepAndTitle().title;
  const totalSteps = 3;

  const handleGoBack = () => {
    resetCustomerCart();
    resetProductsCart();
    resetCustomerCartStatus();
    resetProductsCartStatus();
    navigate('BatchTicketRequests');
  };

  return {
    handleGoBack,
    currentStep,
    totalSteps,
    stepTitle,
    isMobile,
  };
};
